// @flow
import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import NumberFormat from 'react-number-format';

import FavoriteIcon from '@components/FavoriteIcon';

import { detailPath } from '@src/app_routes/bands';

import css from '@styles/bandSearch';
import { itemIndexableSeries } from '../../utils/favorites';

import { trackSelectItem } from '../../utils/googleAnalytics';

import type { TBandSearchResultItem } from '@types/band';

type TProps = {
  item: TBandSearchResultItem
};

function handleSelectItem(e, item) {
  if (!window) return;

  e.preventDefault();

  // fire track event before navigating
  try {
    trackSelectItem(item);
  } catch (_e) {
    // no-op
  }

  window.location = e.currentTarget.href;
}

function CatalogItem ({ item }: TProps) {
  const [hovered, setHovered] = useState(false);
  const dispatch = useDispatch();
  const isFavorited = useSelector((state) => {
    const series = state.settingFavorites.series || [];

    return (
      series.indexOf(itemIndexableSeries(item.lumera_series, item.metal)) !== -1
    );
  });

  const handleFavoriteToggle = useCallback(
    () => {
      dispatch({
        type: 'TOGGLE_FAVORITE_SETTING',
        item: {
          sku: item.vendor_sku,
          series: itemIndexableSeries(item.lumera_series, item.metal)
        }
      });
    },
    [dispatch, item.vendor_sku, item.lumera_series, item.metal]
  );

  const normalImage = item.fully_set_images[0].standard;
  const hoverImage = (item.fully_set_images[1] || {}).standard;

  const imageSrc = hovered && hoverImage ? hoverImage : normalImage;

  return (
    <div
      className={css.item}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}>
      <a href={detailPath(item)} className={css.imageLink} onClick={(e) => handleSelectItem(e, item)}>
        <img src={imageSrc} className={css.itemImage} alt="Wedding band" />
        <FavoriteIcon
          className={css.favoriteLink}
          selected={isFavorited}
          onClick={handleFavoriteToggle}
        />
      </a>
      <p className={css.itemDescription}>
        <a href={detailPath(item)} className={css.itemLink}>
          {item.short_description}
        </a>
      </p>
      <p className={css.itemPrice}>
        <NumberFormat
          value={item.retail_price}
          displayType={'text'}
          thousandSeparator
          prefix={'$'}
          decimalScale={0}
        />
      </p>
    </div>
  );
}

export default CatalogItem;
